import { ThemeProvider } from "./ui/theme-provider"
import { TooltipProvider } from "./ui/tooltip"
import { Toaster } from "./ui/toaster"

export function Providers({ children }) {
  return (
    <ThemeProvider defaultTheme="light" storageKey="ui-theme">
      <TooltipProvider>
        {children}
        <Toaster />
      </TooltipProvider>
    </ThemeProvider>
  )
}
